import { useContext, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { eHOME, ePrivileges } from "../../../utils/enum";
import { UserContext } from "../../../context";
import Utils from "../../../utils";
import styles from "./home.module.css";

import { TContext, TPrivilege } from "../../../types/config";
import ScannerForm from "../warranty/serial-scanner-form";
import CommingSoon from "../../../components/comming-soon";
import Level1Form from "../evaluation/l1-form";

function HomeList() {
  const navigate = useNavigate();
  const context: TContext = useContext(UserContext);
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeEntity, setActiveEntity] = useState<string>(
    eHOME.INCOMING_REQUEST
  );

  useEffect(() => {
    setActiveEntity(
      Utils.isUserHasAccess(
        context.user?.privilegeList as TPrivilege[],
        ePrivileges.VIEWINCOMINGSCAN
      )
        ? eHOME.INCOMING_REQUEST
        : Utils.isUserHasAccess(
              context.user?.privilegeList as TPrivilege[],
              ePrivileges.PERFORMLEVEL1SCAN
            )
          ? eHOME.LEVEL_1
          : Utils.isUserHasAccess(
                context.user?.privilegeList as TPrivilege[],
                ePrivileges.PERFORMLEVEL2SCAN
              )
            ? eHOME.LEVEL_2
            : ""
    );
  }, [context?.user]);

  // useEffect(() => {
  //   const activeTab = searchParams.get("activeTab");
  //   if (activeTab && Object.values(eHOME).includes(activeTab as eHOME)) {
  //     setActiveEntity(activeTab);
  //   }
  // }, []);

  const handleTabClick = (entity: string) => {
    setActiveEntity(entity);
    setSearchParams({ activeTab: entity });
  };

  return (
    <>
      <div className={styles.parentContainer}>
        {/* Check if user has permission to view customer menu */}
        {Utils.isUserHasAccess(
          context.user?.privilegeList as TPrivilege[],
          ePrivileges.VIEWINCOMINGSCAN
        ) && (
          <div
            className={`${styles.tab} ${
              activeEntity === eHOME.INCOMING_REQUEST ? styles.activeTab : ""
            }`}
            onClick={() => handleTabClick(eHOME.INCOMING_REQUEST)}
          >
            <span
              className={
                activeEntity === eHOME.INCOMING_REQUEST
                  ? styles.activeText
                  : styles.inactiveText
              }
            >
              Incoming Scan
            </span>
          </div>
        )}

        {Utils.isUserHasAccess(
          context.user?.privilegeList as TPrivilege[],
          ePrivileges.PERFORMLEVEL1SCAN
        ) && (
          <div
            className={`${styles.tab} ${
              activeEntity === eHOME.LEVEL_1 ? styles.activeTab : ""
            }`}
            onClick={() => handleTabClick(eHOME.LEVEL_1)}
          >
            <span
              className={
                activeEntity === eHOME.LEVEL_1
                  ? styles.activeText
                  : styles.inactiveText
              }
            >
              Eval - L1
            </span>
          </div>
        )}

        {/* {Utils.isUserHasAccess(
          context.user?.privilegeList as TPrivilege[],
          ePrivileges.PERFORMLEVEL2SCAN
        ) && (
          <div
            className={`${styles.tab} ${
              activeEntity === eHOME.LEVEL_2 ? styles.activeTab : ""
            }`}
            onClick={() => handleTabClick(eHOME.LEVEL_2)}
          >
            <span
              className={
                activeEntity === eHOME.LEVEL_2
                  ? styles.activeText
                  : styles.inactiveText
              }
            >
              Eval - L2
            </span>
          </div>
        )} */}
        {/* )} */}
        {/* Check if user has permission to view service partner menu */}
      </div>
      <div className={styles.content_home}>
        {activeEntity === eHOME.INCOMING_REQUEST ? (
          <ScannerForm></ScannerForm>
        ) : activeEntity === eHOME.LEVEL_1 ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignContent: "center",
            }}
          >
            <Level1Form />
          </div>
        ) : activeEntity === eHOME.LEVEL_2 ? (
          <CommingSoon></CommingSoon>
        ) : null}
      </div>
    </>
  );
}

export default HomeList;
